module.exports = __webpack_public_path__ + "img/cns_email_mac8.e006b0bc.png";